import { render, staticRenderFns } from "./LocationGroups.vue?vue&type=template&id=f3af64be&"
import script from "./LocationGroups.vue?vue&type=script&lang=js&"
export * from "./LocationGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports